import { AxiosError } from 'axios';

import type { TFunction } from 'i18next';

export type TranslationMapType = Record<string, string> & { default: string };

const translateFromMap = (
  t: TFunction,
  map: TranslationMapType,
  key?: string
) => {
  const i18nKey = key && key in map ? map[key] : map.default;
  return t(i18nKey);
};

const resolveErrorAlert = (
  t: TFunction,
  error: AxiosError<unknown>,
  alertMap: Record<string, string>
): string => {
  const data = (error.response?.data ?? {}) as Record<string, string>;

  for (const key of Object.keys(data)) {
    if (key in alertMap) {
      return t(alertMap[key]);
    }
  }

  return t(alertMap.default);
};

export { translateFromMap, resolveErrorAlert };
